import React from 'react';

/**
 * Campo Honeypot - Campo oculto para detectar bots
 * Los bots suelen completar todos los campos, incluyendo los ocultos
 * Los usuarios humanos no deberían ver ni completar este campo
 */
const HoneypotField = ({ value, onChange }) => {
  return (
    <div
      style={{
        position: 'absolute',
        left: '-9999px',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        opacity: 0,
        pointerEvents: 'none',
      }}
      aria-hidden="true"
    >
      <label htmlFor="website-url">
        No completar este campo (solo para bots)
      </label>
      <input
        type="text"
        id="website-url"
        name="website-url"
        value={value}
        onChange={onChange}
        tabIndex="-1"
        autoComplete="off"
      />
    </div>
  );
};

export default HoneypotField;

